export default {
	computed: {
		gallery() {
			return [
				{ 
					title: this.$t('ServiceTitleAutografika'),
					folderName: 'autografika', 
					images: [
						require('@/assets/images/gallery/autografika/1.jpg'),
						require('@/assets/images/gallery/autografika/2.jpg'),
						require('@/assets/images/gallery/autografika/3.jpg'),
						require('@/assets/images/gallery/autografika/4.jpg'),
						require('@/assets/images/gallery/autografika/5.jpg'),
						require('@/assets/images/gallery/autografika/6.jpg'),
						require('@/assets/images/gallery/autografika/7.jpg'),
						require('@/assets/images/gallery/autografika/8.jpg'),
						require('@/assets/images/gallery/autografika/9.jpg'),
						require('@/assets/images/gallery/autografika/10.jpg'),
						require('@/assets/images/gallery/autografika/11.jpg'),
						require('@/assets/images/gallery/autografika/12.jpg'),
						require('@/assets/images/gallery/autografika/13.jpg'),
						require('@/assets/images/gallery/autografika/14.jpg'),
						require('@/assets/images/gallery/autografika/15.jpg'),
						require('@/assets/images/gallery/autografika/16.jpg'),
						require('@/assets/images/gallery/autografika/17.jpg'),
						require('@/assets/images/gallery/autografika/18.jpg'),
					],
					imageID: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]
				},
				{ 
					title: this.$t('ServiceTitleCerade'),
					folderName: 'cerade-baneri',
					images: [
						require('@/assets/images/gallery/cerade-baneri/1.jpg'),
						require('@/assets/images/gallery/cerade-baneri/2.jpg'),
						require('@/assets/images/gallery/cerade-baneri/3.jpg'),
						require('@/assets/images/gallery/cerade-baneri/4.jpg'),
					],
					imageID: [1, 2, 3, 4]
				},
				{ 
					title: this.$t('ServiceTitleForeksPleksi'),
					folderName: 'forekspleksi', 
					images: [
						require('@/assets/images/gallery/forekspleksi/1.jpg'),
						require('@/assets/images/gallery/forekspleksi/2.jpg'),
						require('@/assets/images/gallery/forekspleksi/3.jpg'),
						require('@/assets/images/gallery/forekspleksi/4.jpg'),
						require('@/assets/images/gallery/forekspleksi/5.jpg'),
						require('@/assets/images/gallery/forekspleksi/6.jpg'),
						require('@/assets/images/gallery/forekspleksi/7.jpg'),
						require('@/assets/images/gallery/forekspleksi/8.jpg'),
						require('@/assets/images/gallery/forekspleksi/9.jpg'),
						require('@/assets/images/gallery/forekspleksi/10.jpg'),
						require('@/assets/images/gallery/forekspleksi/11.jpg'),
					],
					imageID: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
				},
				{ 
					title: this.$t('ServiceTitlePVC'),
					folderName: 'pvc-naljepnice', 
					images: [
						require('@/assets/images/gallery/pvc-naljepnice/1.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/2.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/3.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/4.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/5.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/6.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/7.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/8.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/9.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/10.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/11.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/12.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/13.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/14.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/15.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/16.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/17.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/18.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/19.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/20.jpg'),
						require('@/assets/images/gallery/pvc-naljepnice/21.jpg'),
					],
					imageID: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]
				},
				{ 
					title: this.$t('GalleryTitleSvijetlece'),
					folderName: 'svijetlece-reklame', 
					images: [
						require('@/assets/images/gallery/svijetlece-reklame/1.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/2.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/3.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/4.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/5.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/6.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/7.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/8.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/9.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/10.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/11.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/12.jpg'),
						require('@/assets/images/gallery/svijetlece-reklame/13.jpg'),
					],
					imageID: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
				},
				{ 
					title: this.$t('GalleryTitleRazno'),
					folderName: 'razno', 
					images: [
						require('@/assets/images/gallery/razno/1.jpg'),
						require('@/assets/images/gallery/razno/2.jpg'),
						require('@/assets/images/gallery/razno/3.jpg'),
						require('@/assets/images/gallery/razno/4.jpg'),
						require('@/assets/images/gallery/razno/5.jpg'),
						require('@/assets/images/gallery/razno/6.jpg'),
						require('@/assets/images/gallery/razno/7.jpg'),
						require('@/assets/images/gallery/razno/8.jpg'),
						require('@/assets/images/gallery/razno/9.jpg'),
						require('@/assets/images/gallery/razno/10.jpg'),
					],
					imageID: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
				}
			] 
		}
	}
}